export const DURACAO_SOM_TRANSICAO_AUDIO_MS = 500;
export const VOLUME_SOM_TRANSICAO_AUDIO = 0.18;
export const NOTAS_SOM_TRANSICAO_AUDIO = [
  { frequencia: 880, inicio: 0, duracao: 0.16 },
  { frequencia: 1320, inicio: 0.14, duracao: 0.3 }
];
